import StatCard from "../../common/StatCard";
import { formatCurrency } from "../../../utils/formatters";
import { Wallet, TrendingUp, TrendingDown, Clock } from "lucide-react";

const WalletSummaryCards = ({ wallet, pendingPayouts }) => {
  const stats = [
    {
      icon: <Wallet size={16} className="text-primary" />,
      label: "Available Balance",
      value: formatCurrency(wallet?.balance ?? 0),
      sub: "Ready to payout",
      accent: "bg-primary/10",
    },
    {
      icon: <TrendingUp size={16} className="text-tertiary" />,
      label: "Total Credits",
      value: formatCurrency(
        wallet?.transactions
          ?.filter(
            (t) => t.transactionType === 0 || t.transactionType === "Credit",
          )
          .reduce((sum, t) => sum + t.amount, 0) ?? 0,
      ),
      sub: "All time earnings",
      accent: "bg-tertiary/10",
    },
    {
      icon: <TrendingDown size={16} className="text-secondary" />,
      label: "Total Debits",
      value: formatCurrency(
        wallet?.transactions
          ?.filter(
            (t) => t.transactionType === 1 || t.transactionType === "Debit",
          )
          .reduce((sum, t) => sum + t.amount, 0) ?? 0,
      ),
      sub: "All time payouts",
      accent: "bg-secondary/10",
    },
    {
      icon: <Clock size={16} className="text-text-muted" />,
      label: "Pending Payouts",
      value: pendingPayouts?.length ?? 0,
      sub: "Awaiting processing",
      accent: "bg-bg-elevated",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((s) => (
        <StatCard key={s.label} {...s} />
      ))}
    </div>
  );
};

export default WalletSummaryCards;
